/* Loaded before app.js: practice projects never reach the normal vault or IndexedDB. */
(()=>{'use strict';
 const active=new URLSearchParams(location.search).get('myerscad-practice')==='1';
 const values=new Map();
 window.MyersCADPractice=Object.freeze({active,storage:Object.freeze({
  getItem:key=>values.has(String(key))?values.get(String(key)):null,
  setItem:(key,value)=>values.set(String(key),String(value)),removeItem:key=>values.delete(String(key)),clear:()=>values.clear()
 })});
})();
